import { Component, type ErrorInfo, type ReactNode } from "react";
import { PageError } from "@/components/PageState";

interface Props {
  children: ReactNode;
  fallback?: ReactNode;
}

interface State {
  error: Error | null;
}

export class ErrorBoundary extends Component<Props, State> {
  state: State = { error: null };

  static getDerivedStateFromError(error: Error): State {
    return { error };
  }

  componentDidCatch(error: Error, info: ErrorInfo) {
    console.error("[ErrorBoundary]", error, info);
  }

  reset = () => {
    this.setState({ error: null });
  };

  render() {
    if (this.state.error) {
      if (this.props.fallback) return this.props.fallback;
      return (
        <div className="min-h-screen flex items-center justify-center bg-background">
          <PageError
            variant="generic"
            title="Something went wrong"
            message={
              this.state.error.message ||
              "An unexpected error occurred while rendering this page."
            }
            onRetry={() => {
              this.reset();
              window.location.reload();
            }}
          />
        </div>
      );
    }
    return this.props.children;
  }
}
